import React from 'react';
import { TabPanel } from '@one-thd/sui-atomic-components';
import { bool } from 'prop-types';
import QuotesCompactList from './QuotesCompactList';
import QuotesCarousel from './QuotesCarousel';
import { useQuoteContext } from '../../hooks/useQuoteContext';

const QuotesTabPanels = () => {
  const {
    activeQuotes,
    expiredQuotes,
    isMobile
  } = useQuoteContext();

  return (
    <div className="sui-pt-3 @sm:sui-pt-4 sui-h-full">
      <TabPanel
        value="active"
        index={0}
        className="sui-h-full"
      >
        {isMobile ? (
          <QuotesCompactList quotes={activeQuotes} />
        ) : (
          <QuotesCarousel quotes={activeQuotes} />
        )}
      </TabPanel>
      <TabPanel
        value="expired"
        index={1}
        className="sui-h-full"
      >
        {isMobile ? (
          <QuotesCompactList quotes={expiredQuotes} />
        ) : (
          <QuotesCarousel quotes={expiredQuotes} />
        )}
      </TabPanel>
    </div>
  );
};

QuotesTabPanels.propTypes = {
};

QuotesTabPanels.defaultProps = {
};

export default QuotesTabPanels;
